<template>
  <div>
    <b-modal id="bv-modal-edit-profile" size="lg" hide-footer>
      <template #modal-title>Edit profile</template>

      <div class="row">
        <div class="col-md-6">
            <label class="form-label pt-2 mb-2">Name</label>
            <input class="form-control2" v-model="user.name">
        </div>
        <div class="col-md-6">
            <label class="form-label pt-2 mb-2">Surname</label>
            <input class="form-control2" v-model="user.surname">
        </div>
      </div>

      <div class="row">
        <div class="col">
            <label class="form-label pt-2 mb-2">Email</label>
            <input class="form-control2" v-model="user.email">
        </div>
      </div>

      <div class="row mt-3 pb-2">
        <div class="col mt-2 mt-md-0">
            <button v-if="updating" type="button" class="btn btn-danger submit col">
            <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
            <button v-else type="button" class="btn btn-danger submit col" @click="saveProfile">Save</button>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
import { EventBus } from '../bus';

export default {
props: ['user'],
  data() {
    return {
      updating: false,
    };
  },

  methods: {

    hideModalEditBanking() {
      this.$bvModal.hide('bv-modal-edit-profile');
    },

            saveProfile() {

             this.updating = true;

              axios.post('/profile/save', {
                name: this.user.name,
                surname: this.user.surname,
                email: this.user.email,
              })
               .then((response) => {

            if (response.data.success) {
                   EventBus.$emit('profile-updated', {
                      name: this.user.name,
                      surname: this.user.surname,
                      email: this.user.email,
                   });
                   this.successAlert(response.data.message);
                   this.hideModalEditBanking();
               } else {
                   this.sweetfire(response.data.message);
               }

              this.updating = false;

            });

          },

      // sweet alert for 3 seconds
      successAlert(text) {

        Swal.fire({
            title: text,
            customClass: {
                title: "popup-title",
                icon: 'custom-icon-size'
            },
            icon: 'success',
            showConfirmButton: false,
            timer: 3000,
            });
      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
  },
};
</script>

<style scoped>
textarea.form-control { font-size: 0.9rem !important; }
</style>